import { Reducer } from 'redux';

import { ActionType } from '../../../store/actionTypes';
import {
  ActionWithPlayload,
  EntityAction,
  ErrorAction,
  isActionWithPayload,
} from '../../../store/types';

export interface InterferenceState {
  [experimentName: string]: {
    isFetching: boolean;
    error?: string;
  };
}

export const initialState: InterferenceState = {};

type Action =
  | ActionWithPlayload<ActionType.FETCH_EXPERIMENT_INTERFERENCE_STARTED>
  | EntityAction<ActionType.FETCH_EXPERIMENT_INTERFERENCE_SUCCEEDED>
  | ErrorAction<ActionType.FETCH_EXPERIMENT_INTERFERENCE_FAILED>;

export const interferenceReducer: Reducer<InterferenceState, Action> = (
  state: InterferenceState = initialState,
  action: Action,
) => {
  if (isActionWithPayload(action)) {
    const experimentName = action.payload.experimentName;

    switch (action.type) {
      case ActionType.FETCH_EXPERIMENT_INTERFERENCE_STARTED:
        return {
          ...state,
          [experimentName]: {
            isFetching: true,
          },
        };
      case ActionType.FETCH_EXPERIMENT_INTERFERENCE_SUCCEEDED:
        return {
          ...state,
          [experimentName]: {
            isFetching: false,
          },
        };
      case ActionType.FETCH_EXPERIMENT_INTERFERENCE_FAILED:
        return {
          ...state,
          [experimentName]: {
            isFetching: false,
            error: action.payload.message,
          },
        };
      default:
        return state;
    }
  }

  return state;
};

export default interferenceReducer;
